<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <table class="detail-table">
      <tbody>
      <tr>
        <td class="label-col">审批状态</td>
        <td>
          <el-tag :type="auditStatus.type">
            {{ auditStatus.text }}
          </el-tag>
        </td>
      </tr>
      <tr>
        <td class="label-col">无需确认成本</td>
        <td>
          <el-tag type="danger"
                  v-if="nodeResult.no_need_confirm">
            无需确认
          </el-tag>
          <el-tag type="success"
                  v-else>
            需要确认
          </el-tag>
          <span class="form-item-tip">无需确认成本时,项目成本将与下方的关联项目保持一致</span>
        </td>
      </tr>
      <template v-if="!nodeResult.no_need_confirm">
        <tr>
          <td class="label-col">前端成本</td>
          <td>{{ (nodeResult.front_cost || '') + ' 元' }}</td>
        </tr>
        <tr>
          <td class="label-col">后端成本</td>
          <td>{{ (nodeResult.backend_cost || '') + ' 元' }}</td>
        </tr>
        <tr>
          <td class="label-col">其他成本</td>
          <td>{{ (nodeResult.other_cost || '') + ' 元' }}</td>
        </tr>
      </template>
      </tbody>
    </table>
    <table class="detail-table"
           v-if="nodeResult.no_need_confirm">
      <tbody>
      <tr>
        <td class="label-col">关联项目</td>
        <td>{{ nodeResult.assign_project_name || '-' }}</td>
      </tr>
      <tr>
        <td class="label-col">项目编号</td>
        <td>{{ nodeResult.assign_project_number || '-' }}</td>
      </tr>
      <tr>
        <td class="label-col">项目ID</td>
        <td>{{ nodeResult.assign_project_id || '-' }}</td>
      </tr>
      </tbody>
    </table>

    <template v-if="!nodeResult.no_need_confirm">
      <div class="detail-group"
           v-for="group in detailGroups"
           :key="group.key">
        <div class="group-title">{{ group.label }}</div>
        <table class="sub-table"
               v-if="detailList(group.key).length > 0">
          <thead>
          <tr>
            <th>费用条目</th>
            <th>金额</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in detailList(group.key)"
              :key="index">
            <td>{{ item.cost_name || '-' }}</td>
            <td>{{ costAmountText(item) }}</td>
          </tr>
          </tbody>
        </table>
        <div class="empty-tip"
             v-else>暂无{{ group.label }}</div>
      </div>
      <table class="detail-table">
        <tbody>
        <tr>
          <td class="label-col">备注</td>
          <td>{{ nodeResult.remarks || '' }}</td>
        </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>

import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {
      node: {
        node_result: {}
      },
      // 状态映射：audit_pass 审批通过 / wait_audit 待审批 / audit_reject 审批驳回
      costAuditStatusMap: {
        audit_pass: {text: '审批通过', type: 'success'},
        wait_audit: {text: '待审批', type: 'warning'},
        audit_reject: {text: '审批驳回', type: 'danger'},
        no_audit: {text: '无需审批', type: 'info'},
      },
      // 明细分组
      detailGroups: [
        {label: '前端成本明细', key: 'front_cost_details'},
        {label: '后端成本明细', key: 'backend_cost_details'},
        {label: '其他成本明细', key: 'other_cost_details'},
      ],
    }
  },
  created () {},
  computed: {
    nodeResult () {
      return this.fullNode.project_node.node_result || {}
    },
    auditStatus () {
      const costAuditStatus = this.nodeResult.cost_audit_status
      return this.costAuditStatusMap[costAuditStatus] || {text: costAuditStatus || '未知', type: 'info'}
    },
  },
  watch: {},
  methods: {
    detailList (key) {
      const list = this.nodeResult[key]
      return Array.isArray(list) ? list : []
    },
    costAmountText (item) {
      const amount = item.cost_amount
      if (amount === null || amount === undefined || amount === '') {
        return ''
      }
      const unit = item.cost_unit || '元/家'
      return amount + ' ' + unit
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}

.record-item {
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
}

.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}

.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}

.detail-table .label-col {
  width: 100px;
  background-color: #fafafa;
  font-weight: bold;
}

/* 成本明细列表 */
.detail-group {
  margin-top: 20px;
}

.group-title {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
  margin-bottom: 10px;
}

.sub-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
}

.sub-table th,
.sub-table td {
  padding: 10px;
  border: 1px solid #ebeef5;
  font-size: 13px;
  color: #606266;
  text-align: left;
}

.sub-table th {
  background-color: #fafafa;
  font-weight: 600;
}

.empty-tip {
  padding: 12px;
  color: #909399;
  font-size: 13px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/ProjectCostConfirmView.vue